<div class="referral-detail-modal">
  <div class="referral-detail-modal__header-top">
    <h2 class="referral-detail-modal__title semi-bold" data-id="referral-detail-name">
      {{ referral.maskedName }}
    </h2>
    <ds-button
      (click)="close.emit()"
      variant="icon"
      size="s"
      icon="xmark"
      label="Close"
      data-id="referral-detail-close"
    />
  </div>

  <div class="referral-detail-modal__meta">
    <span class="referral-detail-modal__referred">
      Referred: {{ referral.referredAt | date: 'MMM d, yyyy' }}
    </span>
    @if (
      showDaysLeftToBook(referral.displayStatus) &&
      referral.daysLeftToBook !== null &&
      referral.daysLeftToBook !== undefined
    ) {
      <span class="referral-detail-modal__badge" data-id="referral-detail-days-left">
        {{ referral.daysLeftToBook }} days left to book
      </span>
    }
  </div>

  <ol class="referral-detail-modal__timeline">
    @for (step of timeline; track step.key) {
      <li class="referral-detail-modal__step referral-detail-modal__step--{{ step.state }}">
        <span class="referral-detail-modal__marker" aria-hidden="true">
          @switch (step.state) {
            @case ('done') {
              <img [src]="REFERRAL_DETAIL_CHECKMARK_ICON" alt="" width="16" height="16" />
            }
            @case ('failed') {
              <img [src]="REFERRAL_DETAIL_FAILED_ICON" alt="" width="16" height="16" />
            }
            @default {
              <img [src]="REFERRAL_DETAIL_CLOCK_ICON" alt="" width="16" height="16" />
            }
          }
        </span>
        <div class="referral-detail-modal__step-body">
          <p class="referral-detail-modal__step-title semi-bold">{{ step.label }}</p>
          <p class="referral-detail-modal__step-description">{{ step.description }}</p>
        </div>
      </li>
    }
  </ol>
</div>
